import papaparse from 'papaparse';

function _exportData(data, delimiter) {
  return papaparse.unparse(data, {delimiter});
}

/**
 * Formats data into CSV.
 * @param data Object to be parsed by `papaparse` library.
 * @returns {String} CSV representation of the data.
 */
const formatCsv = (data) => {
  // eslint-disable-next-line max-len
  // https://superuser.com/questions/568429/excel-csv-import-treating-quoted-strings-of-numbers-as-numeric-values-not-strin
  if(data.forEach){ // Only applies for influence intelligence
    data.forEach((item) => {
      if(item.id){
        item.id = `="${item.id}"`;
      }
    });
  }
  return _exportData(data, ',');
};

/**
 * Formats data into TSV.
 * @param data Object to be parsed by `papaparse` library.
 * @returns {String} TSV representation of the data.
 */
const formatTsv = (data) => {
  return _exportData(data, '\t');
};

export {
  formatCsv,
  formatTsv
};
